import { createElement, Fragment } from 'react';
import {
  Activity,
  BarChart3,
  Bell,
  BookOpen,
  Bot,
  Briefcase,
  Calendar,
  ChevronLeft,
  Database,
  FileText,
  GitBranch,
  GraduationCap,
  History,
  Home,
  Image,
  Inbox,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  PlayCircle,
  Send,
  Settings,
  Star,
  Tag,
  Target,
  TrendingUp,
  UserCheck,
  UserCircle,
  UserPlus,
  Users,
  Video,
  XCircle,
  Youtube,
} from 'lucide-react';
import { getStageIcon } from '../../utils/stageIconUtils.js';

const ICONS = {
  Activity,
  BarChart3,
  Bell,
  BookOpen,
  Bot,
  Briefcase,
  Calendar,
  ChevronLeft,
  Database,
  FileText,
  GitBranch,
  GraduationCap,
  History,
  Home,
  Image,
  Inbox,
  Layers,
  LayoutDashboard,
  LifeBuoy,
  PlayCircle,
  Send,
  Settings,
  Star,
  Tag,
  Target,
  TrendingUp,
  UserCheck,
  UserCircle,
  UserPlus,
  Users,
  Video,
  XCircle,
  Youtube,
};

function resolveIcon(iconName) {
  if (typeof iconName !== 'string') return iconName;
  if (iconName.startsWith('stage:')) return getStageIcon(iconName.slice('stage:'.length));
  return ICONS[iconName] || FileText;
}

export function createTalentNavigationIconProjector() {
  return (iconName, item, metadata = {}) => {
    const Icon = resolveIcon(iconName);
    const accessibleCount = metadata.notificationCountLabel;

    return createElement(Fragment, null,
      createElement(Icon, {
        'aria-hidden': 'true',
        className: 'h-5 w-5',
        focusable: 'false',
      }),
      accessibleCount
        ? createElement('span', { className: 'sr-only' }, accessibleCount)
        : null,
    );
  };
}
